module.exports = "/_next/static/images/kg-28554a61f7e9c19e263199a6ae5c805f.svg";